// @flow
import React from "react";
import PrototypeNavigation from "../components/PrototypeNavigation";
import Main from "../components/Main";

const Frame = ({ width, height, path, title }) =>
  <div className="Frame">
    <dl className="instructions">
      <div>
        <dt>iframe src</dt><dd>index.html#{path}</dd>
      </div>
      <div>
        <dt>iframe height</dt><dd>{height}</dd>
      </div>
    </dl>
    <iframe
      title={title}
      src={`?iframe#${path}`}
      width={width}
      height={height}
      frameBorder="0"
      allowTransparency="true"
      scrolling="no"
    />
    <style jsx>{`
      .Frame {
        background: #fff;
        border: 1px solid #cfcfcf;
        margin: 0 0 20px 0;
      }
      .instructions {
        color: #555;
        background: #efefef;
        padding: 10px;
        margin: 0;
      }
      .instructions div {
        display: flex;
        font-size: 12px;
      }
      .instructions dt {
        width: 100px;
      }
      .instructions dd {
        font-weight: bold;
        flex: 1 1 0;
        padding: 0;
        margin: 0;
      }
      iframe {
        margin: 20px;
      }
    `}</style>
  </div>;

export default () =>
  <div>

    <PrototypeNavigation />

    <Main>
      <div className="frames">
        <Frame title="Quiz desktop" path="quiz" width="944" height="484" />
        <Frame
          title="Slope Chart Factors desktop"
          path="slope-factors"
          width="944"
          height="864"
        />
        <Frame
          title="Slope Chart Wealth desktop"
          path="slope-wealth"
          width="944"
          height="495"
        />
        <Frame title="Quiz mobile" path="quiz" width="320" height="504" />
        <Frame
          title="Slope Chart Factors mobile"
          path="slope-factors"
          width="320"
          height="880"
        />
        <Frame
          title="Slope Chart Wealth mobile"
          path="slope-wealth"
          width="320"
          height="503"
        />
      </div>
    </Main>

    <style jsx global>{`
      html, body {
        height: 100%
      }

      body {
        margin: 0;
        font-family: sans-serif;
        background: #efefef;
      }
    `}</style>

    <style jsx>{`
      .frames {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 50px 0;
      }
      iframe {
        border: 1px solid #cfcfcf;
        margin: 0 0 20px 0;
      }
    `}</style>
  </div>;



// WEBPACK FOOTER //
// ./src/pages/index.js